export default __webpack_public_path__ + "static/media/fallout-item-1.907971b0.png";